import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreLocatorListItem',
  props: {
    location: null
  },
  setup(__props: any) {

const props = __props as {location: IMapStoreLocation}



const directionsLink = computed(() => `https://www.google.com/maps/dir//${encodeURI(
    `${props.location.address} ${props.location.addressLine2}`
)}/`);
const textColor = computed(() => store.getters['app/textColor']);

return { __sfc: true,props, directionsLink, textColor }
}

})